import React from 'react';

const ConfirmationModal = ({ onConfirm, onCancel }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded shadow-md">
                <h2 className="text-lg font-bold">Confirm Send</h2>
                <p>Are you sure you want to send the reminders?</p>
                <div className="flex justify-end mt-4">
                    <button
                        onClick={onConfirm}
                        className="bg-blue-600 text-white font-bold py-2 px-4 rounded mr-2"
                    >
                        Yes, Send
                    </button>
                    <button
                        onClick={onCancel}
                        className="bg-red-600 text-white font-bold py-2 px-4 rounded"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
